var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.633 8.78453L15.2176 4.36295C14.2917 3.43568 13.0148 2.93789 11.7087 3.00621L6.83526 3.24047C4.88587 3.32832 3.33611 4.88026 3.23864 6.82264L3.00472 11.703C2.94623 13.0109 3.43358 14.2895 4.35954 15.2168L8.7749 19.6384C10.5878 21.4539 13.5314 21.4539 15.3541 19.6384L19.633 15.3535C21.4557 13.5477 21.4557 10.6 19.633 8.78453ZM9.56441 12.3765C8.01464 12.3765 6.75729 11.1173 6.75729 9.56538C6.75729 8.01344 8.01464 6.75431 9.56441 6.75431C11.1142 6.75431 12.3715 8.01344 12.3715 9.56538C12.3715 11.1173 11.1142 12.3765 9.56441 12.3765Z",
    fill: "#037DD6"
  })));
};
export default SvgTag;